module.exports = require('./lib/murmurHash3js');



//////////////////
// WEBPACK FOOTER
// ./~/murmurhash3js/index.js
// module id = 353
// module chunks = 0